<template>
  <popup ref="Message" :show="show">
    <div class="ui-message">
      <div class="ui-message-header">
        <img @click="onClose" :src="`${$cdn}images/img_guestbook_close@2x.png`" alt="" />
        <p>{{title}}</p>
      </div>
      <div class="ui-message-main">
        <!-- <img :src="`${$cdn}images/img_guestbook_${icon}@2x.png`" alt="" /> -->
        <span>{{tips}}</span>
      </div>
    </div>
  </popup>
</template>
<script>
import Popup from "./popup";
export default {
  name: "ui-alert",
  components: {
    Popup,
  },
  data() {
    return {
      show: false,
      duration: 0,
      title: "您的关注，会让我们做得更好！",
      tips: "留言成功！",
      content: "",
      okText: "确定",
      ok: null,
      icon:'success'
    };
  },
  methods: {
    onOk() {
      if (this.ok && this.ok(this) === false) {
        return;
      }
      this.onClose();
    },
    onClose() {
      setTimeout(() => {
        this.show = false;
        document.body.removeChild(this.$el);
        this.$destroy();
      }, this.duration);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/globalVars.less";

@liH: 50px;

textarea::placeholder {
  color: #382e2c;
}

.ui-message {
  width: 50vw;
  height: 140px;
  position: relative;
  background: #f5ede2;
  padding: 20px 50px;
  .ui-message-header {
    text-align: center;
    margin: 0 auto;
    p {
      color: @theme;
      font-size: 20px;
      font-weight: bold;
    }
    img{
        position: absolute;
        right: 6px;
        top: 6px;
        width: 24px;
        height: 24px;
        cursor: pointer;
    }
  }
  .ui-message-main {
      text-align: center;
      width: 100%;
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%,-50%);
        >span{
            display: inline-block;
            vertical-align: middle;
            font-size: 14px;
        }
        img{
            vertical-align: middle;
            width: 52px;
            height: 52px;
            margin-right: 12px;
        }
  }
  .ui-message-footer {
    text-align: center;
    margin-top: 20px;
    .ui-button {
      display: inline-block;
      cursor: pointer;
      font-size: 14px;
      width: 104px;
      height: 38px;
      line-height: 38px;
      border: none;
      background: url("@{cdn}img_guestbook_btnbg_normal@2x.png") no-repeat
        center center;
      background-size: 100% 100%;
      color: #382e2c;
      &:first-of-type {
        margin-right: 30px;
      }
    }
    .submit {
      background: url("@{cdn}img_guestbook_btnbg_first@2x.png") no-repeat center
        center;
      background-size: 100% 100%;
      color: #f5ede2;
    }
  }
}
</style>
